import React from 'react';

import classNames from 'classnames';

import DateRangeControl from './DateRangeControl';
import GranularityToggle from './GranularityToggle';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';

export default function FilterBar({
    events,
    selectedCount,
    dateRange,
    coveredRange,
    granularity,
    presets,
    onOpenPicker,
    onApplyPreset,
    onApplyLifetime,
    onApplyCustom,
    onChangeGranularity,
}) {
    return (
        <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-x-8 tw-gap-y-4">
            <div>
                <div className="tw-text-sm tw-text-blue-75 tw-font-medium tw-mb-2">{$t('Projects')}</div>
                <button
                    type="button"
                    onClick={onOpenPicker}
                    className={classNames(
                        'tw-flex tw-items-center tw-justify-between tw-gap-2 tw-min-w-[200px]',
                        'tw-border-2 tw-border-grey tw-rounded-lg tw-text-sm tw-px-3 tw-py-1.5 tw-bg-white',
                    )}
                >
                    <span className="tw-text-charcoal">
                        {selectedCount === events.length && events.length > 0
                            ? $t('All projects')
                            : $t('{{count}} of {{total}} projects', { count: selectedCount, total: events.length })}
                    </span>
                    <ChevronDownIcon className="tw-w-3 tw-h-3" />
                </button>
            </div>
            <DateRangeControl
                dateRange={dateRange}
                coveredRange={coveredRange}
                presets={presets}
                onApplyPreset={onApplyPreset}
                onApplyLifetime={onApplyLifetime}
                onApplyCustom={onApplyCustom}
            />
            <GranularityToggle value={granularity} onChange={onChangeGranularity} />
        </div>
    );
}
